import React from 'react';
import StandardMarkdown from '@modules/ui/markdown/components/StandardMarkdown';
import ErrorBoundary from './DErrorBoundary';
import LegacyReferenceLayout from './LegacyReferenceLayout';

// plugin with passed in components for use in custom layout.
// presets are already included.
export const LegacyReferenceLayoutPlugin = () => {
  return {
    components: {
      LegacyReferenceLayout,
      ErrorBoundary,
      Markdown: ({ source }: any) => {
        return (
          <div className='renderedMarkdown'>
            <StandardMarkdown>{source}</StandardMarkdown>
          </div>
        );
      },
    },
  };
};

export default LegacyReferenceLayoutPlugin;
